import React from "react";
import {createRoot} from "react-dom/client";
import {JustBeforeInitLibs_listeners, JustBeforeUI_listeners} from "./Main.js";
import "./Server/DBShape.js"; // this import is just to ensure that all db-entry types/schemas get registered
import "./Utils/Diagnostics/Diagnostics.js"; // this import is just to ensure that the diag object gets created/exported
import "./Utils/General/ConsoleHelpers.js";
import {InitLibs} from "./Utils/LibIntegrations/@InitLibs.js";

//const InitLibs = require("./Utils/LibIntegrations/@InitLibs.js").InitLibs;
JustBeforeInitLibs_listeners.forEach(a=>a());
InitLibs();

// start auto-runs after libs are initialized (moved to just after store+firelink are created, in MobXFirelink.ts)
//require("Utils/AutoRuns");

const mountNode = document.getElementById("root") as HTMLDivElement;
//const {RootUIWrapper} = require("./UI/Root.js");
const {RootUIWrapper} = require("./UI/Root");

JustBeforeUI_listeners.forEach(a=>a());
const root = createRoot(mountNode);
root.render(<RootUIWrapper/>);